import { z } from 'zod';
import { encryptedKeyByAesKeyValidator, encryptedKeyByRsaKeyValidator, } from '#validation';
import { CommonMemberCreateSchema } from './common-member-create.schema';
export const ServiceAccountMemberCreateSchema = CommonMemberCreateSchema.extend({
    ePrivateKeyByAccountKey: encryptedKeyByAesKeyValidator, // analog of ePrivateKeyByUserKey for user members
    eInvitationPrivateKeyByMemberKey: z.string(),
    eAdminPrivateKeyByMemberKey: encryptedKeyByRsaKeyValidator.optional(),
});
